// extracted by mini-css-extract-plugin
export var container = "_4n-0";
export var fallback = "_4n-5";
export var fallbackIcon = "_4n-6";
export var hidden = "_4n-2";
export var image = "_4n-3";
export var loaded = "_4n-4";
export var placeholder = "_4n-1";